import template from './passwordRequirementsCheck.html';
import { PasswordRequirementsCheckController as controller } from './passwordRequirementsCheck.controller';

export default {
  restrict: 'E',
  controller,
  controllerAs: 'vm',
  bindings: {
    password: '@',
    onChange: '&',
  },
  template,
};
